import(/* webpackMode: "eager" */ "/usr/src/app/myomers/src/app/error.tsx");
